import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ref } from 'vue';
import modelModal from '@/core/models/ModelModal';
import environment from '@/environment/environment';
import routes from '../routes';
import SessionData from '../models/SessionData';
import config from '../../../public/config/config.json';

class SessionDataService {
  intervalTime = null;

  delay = (environment.environment.production)
    ? config.configuration.delayActivityPROD
    : config.configuration.delayActivityDEV;

  store = useStore();

  router = useRouter();

  dataSession = SessionData;

  propertiesModal = ref(modelModal);

  static flagSessionActivate = false;

  static initSession(objSession = this.dataSession) {
    this.dataSession = objSession;
    this.flagSessionActivate = true;
  }

  static setUpdateSession(key, value) {
    this.dataSession[key] = value;
  }

  static getSession() {
    return this.dataSession;
  }

  async activityUser() {
    const valueStorage = +localStorage.getItem('mngr');
    const currentTime = new Date().getTime();
    if ((currentTime - valueStorage) >= this.delay) {
      if (localStorage.getItem('mngr') !== null) {
        localStorage.removeItem('mngr');
        this.dataSession = null;
        this.propertiesModal.value = {
          showModal: true,
          routeRedirection: routes.ROUTES.landing,
          message: 'Tu sesión ha expirado.',
          textButton: 'Salir',
        };
        this.store.dispatch('showModalWarning', this.propertiesModal.value);
      }
    }
  }

  initGetActivityUserTime = () => {
    this.intervalTime = setInterval(this.activityUser.bind(this), 60 * 1000);
  }

  async goOffline() {
    this.store.commit('showSpinner');
    this.dataSession = null;
    setTimeout(() => {
      this.store.commit('hideSpinner');
      this.router.push(routes.ROUTES.landing);
    }, 700);
  }
}
export default SessionDataService;
